module.exports = __webpack_public_path__ + "static/media/red-hero.9d1fe550.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/red-hero.svg
// module id = 1379
// module chunks = 0